export const BUILD_VERSION = '1779466372';
